module.exports = __webpack_public_path__ + "img/michael.9d0b9c8e.png";